<style scoped lang="scss">
.application-hero {
  background: #333;
}

.mobile-program-container {
  padding-top: 16px;
  padding-bottom: 16px;
  padding-right: 24px;
  border: thin solid #999;
  border-radius: 8px;
  margin-bottom: 16px;
}

.ml-35 {
  margin-left: 35px !important;
}
</style>

<template>
    <div v-if="user">
        <loading :active.sync="isLoading" 
            can-cancel="false">
        </loading>
        <div class="uk-container uk-container-center" id="section-loader">
            <div id="apply-area" class="uk-margin-large-bottom">
                <div class="uk-grid">
                    <div class="uk-width-9-10 uk-align-center">
                        <h2>{{ user.person.first_name }} {{ user.person.last_name }}'s {{ __('global.applications') }}</h2>
                        <div class="uk-grid uk-hidden-medium uk-hidden-large mobile-program-container"
                             v-for="application in user.household_applications">

              <div class="uk-width-1-1 uk-text-bold uk-text-large">{{
                  application.program.program_name
                }}
              </div>
              <div class="uk-width-1-1 uk-text-muted uk-text-small">APPLICATION #{{ application.id }}
              </div>
              <div class="uk-width-1-1 uk-margin-small-top uk-text-bold">Status: {{
                  application.status.program_application_status_name
                }}
              </div>
              <div class="uk-width-1-1 uk-margin-small-top" v-if="application.status.description">{{
                  application.status.description
                }}
              </div>
              <div class="uk-width-1-1 uk-margin-top">
                <div class="uk-width-1-1 uk-margin-bottom">
                  <router-link
                      class="uk-button uk-width-1-1 uk-margin-bottom uk-button-primary uk-button-large"
                      :to="'/application/'+application.id"
                      v-if="application.status.id != 1 && application.status.allow_household_edit">
                    {{ __('global.edit') }} {{ __('global.application') }}
                  </router-link>
                  <router-link
                      class="uk-button uk-width-1-1 uk-margin-bottom uk-button-primary uk-button-large"
                      :to="'/application/'+application.id" v-if="application.status.id === 1">
                    {{ __('global.begin') }} {{ __('global.application') }}
                  </router-link>
                  <router-link class="uk-button uk-width-1-1 uk-margin-bottom " :to="'/'"
                               v-if="application.status.waitlist">{{ __('global.waitlisted') }}
                  </router-link>
                  <a :href="'/hope/prequal-letter/'+application.id"
                     v-if="application.status.show_prequal_letter"
                     class="uk-button uk-button-primary uk-width-1-1 uk-margin-top uk-margin-bottom">{{
                      __('global.prequalification-letter')
                    }}</a>
                    <a :href="'/hope/payment-letter/'+application.id" target="_blank"
                        v-if="application.payment_letter_available && application.status.show_payment_letter"
                        class="uk-button uk-button-primary uk-width-1-1 uk-margin-bottom uk-text-capitalize">{{ __('global.payment-letter') }}</a>
                  <a v-if="showReapplyButton(application)" href="javascript:;"
                     class="uk-button uk-button-primary uk-width-1-1">
                    <button :disabled="isLoading"
                            @click="createApplication(application.reapply_program_id, application.can_reopen, application.id)"
                            class="uk-button uk-button-primary uk-width-1-1">{{ __('global.re-apply') }}
                    </button>
                  </a>
                </div>
              </div>
            </div>
            <div class="uk-overflow-auto uk-hidden-small" style="overflow:scroll">
              <table class="uk-table uk-table-striped">
                <thead>
                <tr>
                  <th class="uk-text-capitalize">{{ __('global.number') }}</th>
                  <th class="uk-text-capitalize">{{ __('global.program') }}</th>
                  <th class="uk-text-capitalize" v-if="showJobsColumns">{{ __('global.student') }}</th>
                  <th class="uk-text-capitalize">{{ __('global.status') }}</th>
                  <th class="uk-text-capitalize">{{ __('global.explanation') }}</th>
                  <th class="uk-text-capitalize">{{ __('global.actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="application in user.household_applications">
                  <td>
                    {{ application.id }}

                  </td>
                  <td>{{ application.program.program_name }}</td>
                  <td v-if="showJobsColumns">
                    <span v-if="application.program_type == 2">{{ application.student_name }}</span>
                    <span v-else>-</span>
                  </td>
                  <td>
                    <span class="status-name">{{ application.status.program_application_status_name }}</span>
                  </td>
                  <td>
                    <span>{{ application.status.description }}</span>
                  </td>
                  <td style="min-width: 200px;">
                    <router-link :to="'/application/'+application.id"
                                 v-if="application.status.id != 1 && application.status.allow_household_edit && application.status.id !== 15"
                                 class="uk-button uk-button-primary uk-width-1-1 uk-margin-bottom uk-text-capitalize">
                      {{ __('global.edit') }} {{ __('global.application') }}
                    </router-link>
                    <router-link :to="'/application/'+application.id"
                                 v-if="application.status.id === 1"
                                 class="uk-button uk-button-primary uk-width-1-1 uk-margin-bottom uk-text-capitalize">
                      {{ __('global.begin') }} {{ __('global.application') }}
                    </router-link>
                    <router-link :to="'/'" v-if="application.status.id === 15"
                                 class="uk-button uk-button-primary uk-width-1-1 uk-margin-bottom uk-text-capitalize">
                      {{ __('global.waitlisted') }}
                    </router-link>
                    <a :href="'/hope/prequal-letter/'+application.id" target="_blank"
                       v-if="application.status.show_prequal_letter"
                       class="uk-button uk-button-primary uk-width-1-1 uk-margin-bottom uk-text-capitalize">{{
                        __('global.prequalification-letter')
                      }}</a>
                      <a :href="'/hope/payment-letter/'+application.id" target="_blank"
                         v-if="application.status.show_payment_letter"
                         class="uk-button uk-button-primary uk-width-1-1 uk-margin-bottom uk-text-capitalize">{{ __('global.payment-letter') }}</a>
                    <button :disabled="isLoading"
                            @click="createApplication(application.reapply_program_id, application.can_reopen, application.id)"
                            v-if="showReapplyButton(application)"
                            class="uk-button uk-width-1-1 uk-text-capitalize"
                            :class="{'uk-button-primary': !application.can_reopen, 'uk-button-success': application.can_reopen}"
                    >
                      {{ __('global.re-apply') }}
                    </button>
                    <button v-if="application.program_type == 2 && !isStudent && user.user_roles[0].key !== 'jobs-student'"
                            @click="reapplyJobs(application)"
                            class="uk-button uk-width-1-1 uk-text-capitalize uk-button-success">
                      Apply For Another Student
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

          </div>

          <div class="uk-width-9-10 uk-align-center uk-margin-top" v-if="availablePrograms.length > 0">
            <h2>Available Programs</h2>
            <table class="uk-width-1-1">
              <tbody>
              <tr v-for="program in availablePrograms" :key="program.id">
                <td class="uk-width-1-5">
                  <img :src="program.logo_url" style="height: 64px;" alt="">
                </td>
                <td class="uk-width-3-5">
                  {{ program.program_name }}
                </td>
                <!--                <td class="uk-width-3-5">{{ program.description }}</td>-->
                <td class="uk-width-1-5">
                  <button :disabled="loading" @click="createJobsApplication(program.id)"
                          class="uk-button uk-button-primary uk-width-1-1">
                    Begin Application
                  </button>
                </td>
              </tr>
              </tbody>
            </table>

          </div>


        </div>

        <!-- <static-information></static-information> -->
      </div>

    </div>


    <!-- SITE FOOTER - CONVERT TO INCLUDE ON NON-LIGHT BOX PAGES -->
    <div class="uk-grid ml-35" data-uk-scrollspy="{cls:'uk-animation-fade', delay:1400}">
      <hr class="uk-hidden-medium uk-hidden-large uk-width-1-1 uk-margin-bottom">
      <div class="uk-width-1-1 uk-width-medium-2-10">
        <img :src="env.PUBLIC_LOGO" :alt="env.PROGRAM_NAME">
        <div v-if="env.PARTNER_ON_DASHBOARD" class="uk-width-1-1 uk-margin-top">
          <p><i>{{ __(`landing.working_with_partner`) }}</i></p>
          <validated-section :errors="errors" field="pid">
            <TextInput
                v-model="fieldPartnerId"
                :name="__(`landing.field_partner_id`)"
                :placeholder="__(`landing.field_partner_id`)"
                rules="required"
            />
          </validated-section>
          <button @click="checkFieldPartnerId" type="submit" :disabled="fieldPartnerLoading || !fieldPartnerId"
                  class="uk-button uk-button-primary uk-width-1-1 uk-margin-top">{{ __('global.submit') }}
          </button>
        </div>
        <div v-else-if="partners.length">
          <div v-for="(item, key) in partners" :key="key" class="uk-margin-top uk-margin-left">
            <div>{{ item.organization_name ? item.organization_name : 'N/A' }}</div>
            <div><b>{{ item.first_name }} {{ item.last_name }}</b></div>
            <div>{{ item.phone ? item.phone.number : 'N/A' }}</div>
            <div>{{ item.email ? item.email.email_address : 'N/A' }}</div>
          </div>
        </div>
      </div>
      <hr class="uk-hidden-medium uk-hidden-large uk-width-1-1 uk-margin-bottom uk-margin-top">
      <div class="uk-width-medium-6-10">
        <h2 v-if="siteSettings['show-phone-number-on-applicant-dashboard']"><a :href="'tel:'+env.PUBLIC_PHONE">{{ env.PUBLIC_PHONE }}</a><br/>
          <small v-if="env.PUBLIC_FAX">FAX: {{ env.PUBLIC_FAX }}</small>
        </h2>
        <template v-if="env.LANG_KEY == 'mn_'">
          <p>{{ __(`tenant.assistance_is_provided`, {program_abbreviation: firstProgram['program_abbreviation']}) }}</p>
          <p>
            {{ __('global.tennessen_warning') }}
          </p>
          <p>
            {{ __(`tenant.purpose_of_this`) }}
          </p>
        </template>
        <template v-else>
          <template v-if="showJobsColumns">
            <p>{{
                __(`landing.assistance_provided_jobs`, {
                  program_abbreviation: firstProgram['program_abbreviation'],
                  program_name: firstProgram['program_name']
                })
              }}</p>
          </template>
          <template v-else>
            <p>{{
                __(`landing.assistance_provided`, {
                  program_abbreviation: firstProgram['program_abbreviation'],
                  program_name: firstProgram['program_name'],
                  agency: firstProgram['agency_name'],
                  agency_site: siteSettings.agency_site,
                })
              }}</p>
          </template>
        </template>

      </div>
      <div class="uk-width-1-1  uk-margin-top uk-margin-bottom">
        <br/>&copy; 2020 <a :href="env.AGENCY_SITE" target="_blank">{{ env.AGENCY_NAME }},
        {{ __('global.all_right_reserved') }}</a>
        <ul class="uk-subnav uk-subnav-line uk-text-center">

          <li><a :href="'/'+firstProgram.slug+'/terms-of-service'" target="_blank"
                 style="color: darkblue; border-bottom: solid 1px darkblue;" v-html="__('global.term_of_service')"></a>
          </li>
          <li><a :href="'/'+firstProgram.slug+'/privacy-policy'" target="_blank"
                 style="color: darkblue; border-bottom: solid 1px darkblue;" v-html="__('global.privacy_security')"></a>
          </li>
        </ul>
        <br/>
      </div>
    </div>


    <!-- BEGIN  Ready Definition Modal -->
    <div id="ready-definition" class="uk-modal">
      <div class="uk-modal-dialog"><a class="uk-modal-close uk-close"></a>
        <h2 class="uk-text-large">{{ __('tenant.what_it_mean') }}</h2>
        <hr/>
        <p>

        <ul>
          <li>{{ __('tenant.your_document_meets') }}</li>
          <li>{{ __('tenant.you_have_your_documents') }}
            <ul>
              <li>{{ __('tenant.high_resolution_scan') }}</li>
              <li>{{ __('tenant.high_resolution_photo') }}</li>
              <li>{{ __('tenant.download_pdf_from') }}</li>
            </ul>
          </li>
          <li>{{ __('tenant.you_have_either') }}
          </li>
        </ul>
        </p>
        <div class="uk-panel-box uk-alert-warning">
          <div class="uk-grid">
            <div class="uk-width-1-10"><i class="uk-icon-exclamation-circle"></i></div>
            <div class="uk-width-9-10">{{ __('tenant.important_check_legibility') }}<a
                href="#legibility-sample" data-uk-modal
                class="uk-button uk-button-mini uk-button-secondary"><i
                class="uk-icon-open"></i>{{ __('tenant.click_here_example') }}</a>
              <hr>
            </div>
          </div>
          <div class="uk-grid">
            <div class="uk-width-1-1">
              <h3 class="uk-text-center">{{ __('tenant.all_doc_ready') }}</h3>

              <a href="#document-check-list" data-uk-modal
                 class="uk-button uk-button uk-button uk-width-9-10 uk-width-small-1-1 uk-width-medium-2-3 uk-margin-bottom uk-align-center uk-animation-fade"><i
                  class="uk-icon-check-square-o"></i> {{ __('tenant.document_checklist') }}</a>

            </div>


          </div>
        </div>
      </div>
    </div>

    <!-- BEGIN Legibility Sample Modal -->
    <div id="legibility-sample" class="uk-modal">
      <div class="uk-modal-dialog"><a class="uk-modal-close uk-close"></a>
        <h2 class="uk-text-large">{{ __('tenant.below_is_sample') }}</h2>
        <hr/>
        <img src="/images/legibility-sample.jpg" alt="Sample of a legigible and illegible document.">
        <p class="uk-hidden-notouch uk-text-small uk-text-center">{{ __('tenant.pinch_zoom_in') }}</p>
        <hr class="uk-grid-divider">
        <h2 class="uk-text-large uk-text-center">{{
            __('tenant.no_digital_copies', {'public_fax': env.PUBLIC_FAX})
          }}</h2>
        <hr/>
        <p class="uk-text-center">{{ __('tenant.be_sure_include_number') }}</p>
        <div class="uk-grid">
          <div class="uk-width-1-1">
            <div class="uk-grid">
              <div class="uk-width-4-10 uk-align-left">
                <a href="#document-check-list" class="uk-button  uk-width-1-1" data-uk-modal><i
                    class="uk-icon-check-square-o"></i> {{ __('tenant.document_checklist') }}</a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- BEGIN No Digital Copies Modal -->
    <div id="no-digital-copies" class="uk-modal">
      <div class="uk-modal-dialog"><a class="uk-modal-close uk-close"></a>
        <h2 class="uk-text-large">{{ __('tenant.no_digital_copies', {'public_fax': env.PUBLIC_FAX}) }}</h2>
        <hr/>
        <p>{{ __('tenant.be_sure_include_number') }}</p>
        <p class="uk-hidden-notouch">{{ __('tenant.pinch_zoom_in') }}</p>
      </div>
    </div>


    <!-- Begin Check List Modal -->
    <div id="document-check-list" class="uk-modal">
      <div class="uk-modal-dialog uk-modal-dialog-blank">
        <div id="document-list-box" class="uk-grid uk-flex-middle">
          <div class=" uk-width-1-6 uk-width-medium-1-3 uk-height-1-1 uk-cover-background uk-row-first "
               style="background-image: url('/images/home-top-bg-mobile.jpg'); background-color:#000; ">&nbsp;
          </div>
          <div class="uk-width-5-6 uk-width-medium-2-3 uk-height-1-1 uk-overflow-container ">
            <div class="uk-grid-collapse">
              <div class="uk-width-9-10 uk-align-left">
                <h2 class="uk-text-center uk-margin-top">{{ __('tenant.document_checklist') }} </h2>
                <hr class="uk-width-1-1 uk-grid-divider"/>
                <h4 v-html="__('tenant.please_make_sure')"><a
                    href="#ready-definition" class="uk-link-muted" data-uk-modal><i
                    class="uk-icon-info-circle"></i>&nbsp;{{ __('tenant.ready_for_upload') }}</a>
                  {{ __('tenant.or_for_fax', {'public_fax': env.PUBLIC_FAX}) }}</h4>
                <hr class="uk-width-1-1 uk-grid-divider"/>
              </div>
            </div>
            <hr class="uk-width-9-10 uk-margin-top uk-margin-bottom"/>
            <div class="uk-grid">
              <div class="uk-width-1-10 "><i class="uk-icon-square-o uk-icon-medium"></i></div>
              <div class="uk-width-8-10 uk-margin-small-left"> {{ __('tenant.two_approved_citizenship') }}
              </div>
            </div>
            <hr class="uk-width-9-10 uk-margin-top uk-margin-bottom"/>
            <div class="uk-grid">
              <div class="uk-width-1-10 "><i class="uk-icon-square-o uk-icon-medium"></i></div>
              <div class="uk-width-8-10 uk-margin-small-left"> {{ __('tenant.two_approved_residency') }}
              </div>
            </div>
            <hr class="uk-width-9-10 uk-margin-top uk-margin-bottom"/>
            <div class="uk-grid">
              <div class="uk-width-1-10 "><i class="uk-icon-square-o uk-icon-medium"></i></div>
              <div class="uk-width-8-10  uk-margin-small-left"> {{ __('tenant.last_12_mortgage') }}
              </div>
            </div>
            <hr class="uk-width-9-10 uk-margin-top uk-margin-bottom"/>
            <div class="uk-grid">
              <div class="uk-width-1-10 "><i class="uk-icon-square-o uk-icon-medium"></i></div>
              <div class="uk-width-8-10  uk-margin-small-left"> {{ __('tenant.copy_late_notice') }}
              </div>
            </div>
            <hr class="uk-width-9-10 uk-margin-top uk-margin-bottom"/>
            <div class="uk-grid">
              <div class="uk-width-1-10 "><i class="uk-icon-square-o uk-icon-medium"></i></div>
              <div class="uk-width-8-10  uk-margin-small-left"> {{ __('tenant.30_days_hh_income') }}
              </div>
            </div>
            <hr class="uk-width-9-10 uk-margin-top uk-margin-bottom"/>
            <div class="uk-grid">
              <div class="uk-width-1-10 "><i class="uk-icon-square-o uk-icon-medium"></i></div>
              <div class="uk-width-8-10  uk-margin-small-left"> {{ __('tenant.copy_utility_bill') }}
              </div>
            </div>
            <hr class="uk-width-9-10 uk-margin-top uk-margin-bottom"/>
            <div class="uk-grid-collapse">
              <div class="uk-width-9-10 uk-width-medium-6-10 uk-align-center uk-text-center">
                {{ __('tenant.all_document_ready') }}
              </div>
              <div class="uk-width-9-10 uk-width-medium-6-10 uk-align-center"><a href="#pre-qualify-form"
                                                                                 data-uk-modal
                                                                                 class="uk-button uk-button-primary uk-button-large uk-width-9-10 uk-width-1-1 uk-width-medium-2-3 uk-margin-bottom uk-align-center "><i
                  class="uk-icon-pencil-square-o"></i> {{ __('tenant.click_here_apply') }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-dialog :title="__('tenant.confirmation')"
                  :confirm-text="__('global.ok')"
                  :cancel-text="__('global.cancel')"
                  ref="confirmSubmitDialog"
                  @confirm="onCompleteModalConfirm">
      <span v-html="__('tenant.field_partner_confirmation', fieldPartnerInfo)"></span>
    </modal-dialog>

    <modal-dialog
        ref="addStudentDialog"
        confirm-text="Create Application"
        :close-on-confirm="false"
        @confirm="onCompleteAddStudentForm"
        title="Create Application For Student">
      <div class="uk-grid">
        <div class="uk-width-1-2">
          <label>Student First Name</label>
          <validated-section :errors="newStudentFormErrors" field="first_name">
            <input v-model="newStudentForm.first_name"
                   placeholder="First Name"
                   type="text" class="uk-input uk-width-1-1 uk-form-large">
          </validated-section>
        </div>
        <div class="uk-width-1-2">
          <label>Student Last Name</label>
          <validated-section :errors="newStudentFormErrors" field="last_name">
            <input v-model="newStudentForm.last_name"
                   placeholder="Last Name"
                   type="text" class="uk-input uk-width-1-1 uk-form-large">
          </validated-section>
        </div>

        <div class="uk-width-1-2 uk-margin-top">
          <label>Student Email Address</label>
          <validated-section :errors="newStudentFormErrors" field="email">
            <input v-model="newStudentForm.email" type="text"
                   placeholder="@"
                   class="uk-input uk-width-1-1 uk-form-large">
          </validated-section>
        </div>

        <div class="uk-width-1-2 uk-margin-top">
          <validated-section :errors="newStudentFormErrors" field="date_of_birth">
            <date-picker :name="__('tenant.birth_date')"
                         :label="__('tenant.birth_date')"
                         autofocus="false"
                         v-model="newStudentForm.date_of_birth" :config="datePickerConfig"
                         :placeholder="__('tenant.birth_date')"/>
          </validated-section>
        </div>

        <div class="uk-width-1-1 uk-margin-top uk-grid">

        </div>
      </div>
    </modal-dialog>
  </div>
</template>

<script>
// var staticPage = "../components/Home/" + this.env.USE_LAYOUT_SET + "/StaticInformation";
import {mapGetters, mapState} from 'vuex';
import PublicHero from "../components/Home/PublicHero";
//import StaticInformation from "../components/Home/lorain-co-oh/StaticInformation";
import ApplicationRow from "../components/Home/ApplicationRow";
import ValidatedSection from "../components/Common/ValidatedSection";
import ModalDialog from "../components/Common/ModalDialog";
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment/moment";

export default {
  name: "HopeIndex",
  components: {ApplicationRow, PublicHero, ValidatedSection, ModalDialog, Loading},
  data() {
    return {
      errors: {},
      process: process,
      fieldPartnerLoading: false,
      fieldPartnerId: undefined,
      fieldPartnerInfo: {},
      isLoading: false,

      newStudentFormErrors: {},
      newStudentForm: {
        program_id: null,
        applicationId: null,
        first_name: '',
        last_name: '',
        email: '',
        date_of_birth: '',
      },
      datePickerConfig: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
      },
    }
  },
  computed: {
    showJobsColumns() {
      for (let i in this.user.household_applications) {
        if (this.user.household_applications[i].program_type == 2) {
          return true;
        }
      }
      return false;
    },
    tosUrl() {
      return '/' + this.firstProgram.slug + '/terms-of-service'
    },
    /**
     * An Available Program can be anything that is not already applied to
     * or has a status of multiple_allowed
     */
    availablePrograms() {
      let programs = [];
      // return programs;
      let currentProgramIds = _.map(this.user.household_applications, h => h.program_id);

      _.each(this.programs, program => {
        if (program.program_type != 2) {
          return;
        }
        if (currentProgramIds.includes(program.id)) {
          return;
        }

        programs.push(program);
      })


      return programs;
    },
    firstProgram() {
      return this.programs && this.programs.length ? this.programs[0] : {}
    },
    ...mapState('App', {
      user: state => state.user,
      env: state => state.env,
      programs: state => state.programs,
      partners: state => state.partners,
      siteSettings: state => state.siteSettings,
    }),
    ...mapState('Application', {
      application: state => state.application,
    }),

    ...mapGetters('Application', ['programSettings']),
    ...mapGetters('App', ['isStudent']),
  },

  watch: {
    fieldPartnerId(newValue, oldValue) {
      if (newValue != oldValue) {
        this.errors = {}
      }
    }
  },
  mounted() {

  },
  methods: {
    checkFieldPartnerId() {
      this.fieldPartnerInfo = {}
      this.errors = {};
      if (!this.fieldPartnerId)
        return false;
      this.fieldPartnerLoading = true;
      axios.post('/api/check-field-partner', {pid: this.fieldPartnerId})
          .then((res) => {
            this.fieldPartnerLoading = false;
            this.fieldPartnerInfo = res.data.data
            this.$refs.confirmSubmitDialog.open();
          })
          .catch((err) => {
            this.fieldPartnerLoading = false;
            if (err.response.data.errors) {
              this.errors = {pid: ['No partners match the code entered, please try again']}
            }
          })
    },

    onCompleteModalConfirm() {
      const param = {
        id: this.fieldPartnerInfo.id
      }
      this.$store.dispatch('App/addFieldPartner', param)
          .then((res) => {
            this.$store.commit('App/SET_PARTNERS', res)
            this.$toast.success('Partner has been successfully added.');
          })
          .catch((err) => {
            this.$toast.error('Something went wrong, try again later.');
          })
    },

    /*
    Date Types:
        0 => 'No Date (disables setting)',
        1 => 'Date Last Applied',
        2 => 'Date Last Funding Approved',
        3 => 'Last Month of Assistance',
    */
    latestDateForPreviousProgramApplication(program, dateType) {
      let latestDate = null;
      _.each(this.user.applications, app => {

      })
    },
    async getPrograms() {
      let r = await axios.get('/api/hope/programs');
      this.$store.commit('App/SET_PROGRAMS', r.data);
    },

    /*
     * Creates a new application for the user for the program
     */
    createApplication(programId, canReopen, appId = null) {
      this.isLoading = true
      canReopen = canReopen ? 1 : 0;
      const params = {
        applicationId: appId
      }
      axios.post('/api/hope/programs/' + programId + '/create-application?reopen=' + canReopen, params).then(res => {
        this.getPrograms();
        this.$store.dispatch('App/fetchUser')
            .then(() => {
              this.isLoading = false;
              this.$toast.success('Application has been successfully created.');
            }).catch((err) => {
          location.reload();
        });
      }).catch((err) => {
        this.isLoading = false;
        if (err.response && err.response.data && err.response.data.error) {
          this.$toast.warning(err.response.data.error);
        } else {
          this.$toast.error('Something went wrong, Please refresh the page and try again.');
        }
      })
    },

    createJobsApplication(programId, canReopen, appId = null) {
      this.newStudentForm.program_id = programId;
      let program = _.find(this.programs, { id: programId })
      console.log('program', program, this.programs);
      let minDate = moment(program.settings['eligibility-age-calculation-date']).subtract(program.settings['eligibility-age-calculation-age'], 'year');
      let options = _.clone(this.datePickerConfig);
      options.maxDate = minDate.format('YYYY-MM-DD');
      this.datePickerConfig = options;

      this.$refs.addStudentDialog.open();
    },

    reapplyJobs(fromApplication) {
      // Show Student Form
      this.newStudentForm.applicationId = fromApplication.id;
      this.newStudentForm.program_id = fromApplication.program_id;

      let minDate = moment(fromApplication.program.settings['eligibility-age-calculation-date']).subtract(fromApplication.program.settings['eligibility-age-calculation-age'], 'year');
      let options = _.clone(this.datePickerConfig);
      options.maxDate = minDate.format('YYYY-MM-DD');
      this.datePickerConfig = options;

      this.$refs.addStudentDialog.open();
    },

    async onCompleteAddStudentForm(e, f, g) {
      console.log(e, f, g)
      this.isLoading = true;
      const params = this.newStudentForm;

      try {
        let {data} = await axios.post('/api/hope/programs/' + params.program_id + '/create-application', params);
      } catch (e) {
        this.newStudentFormErrors = e.response.data.errors;
        this.isLoading = false;
        return;
      }

      window.location.reload();
    },

    /*
     * User can reapply for a program if:
     * - program.can_reapply is set to true
     * - application is the latest application for the user in the program
     * - program has not ended OR the program setting to allow after closed is set to true
     */
    showReapplyButton(application) {
      return application.reapply_program_id !== null;
    }
  }
}
</script>
